import { render } from "./PiaProductTable.vue?vue&type=template&id=d322dcfe&scoped=true"
import script from "./PiaProductTable.vue?vue&type=script&lang=js"
export * from "./PiaProductTable.vue?vue&type=script&lang=js"

import "./PiaProductTable.vue?vue&type=style&index=0&id=d322dcfe&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d322dcfe"]])

export default __exports__